module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "-6em"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mt-200"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "hero-image-inner",
    staticStyle: {
      "background-image": "none"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "home-form-wrapper",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "home-form-inner col-sm-12 col-md-6 col-md-offset-2"
  }, [_c('form', [_c('h4', {
    staticStyle: {
      "color": "#000000",
      "line-height": "1.4"
    }
  }, [_vm._v("Search for Pre-verified Cityneeds Professional Workers (CNpros), or Listed Businesses")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "columns": "#000000"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("This service is only available in Abuja for now")])])])])])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row background-brand-blue",
    staticStyle: {
      "margin": "1em 5px"
    }
  }, [_c('div', {}, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "boxable-cta-right col-md-5 col-sm-12 col-xs-12 pull-right",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "102%"
    }
  }, _vm._l((_vm.cnsurveys), function(survey, index) {
    return _c('div', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": "/cnsurveys"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 1),
        expression: "(index) < 1"
      }],
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_vm._v(_vm._s(survey.cnsurvey_title))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }],
        key: index2
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt, index22) {
        return _c('div', {
          key: index22,
          staticClass: "options"
        }, [_c('div', [_c('div', {
          staticClass: "radio",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('input', {
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-default pull-right"
      }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])], 2)
    }))])])], 1)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "block fullwidth",
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "row regular-section"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12 regular-boxes"
  }, [_c('div', {
    staticClass: "regular-boxes-cta"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Get instant help on any of our services")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000",
      "margin-top": "3em"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Call our Hotline")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "block background-black-light",
    staticStyle: {
      "min-height": "14em",
      "margin-top": "5em",
      "padding-bottom": "2em"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "#fff",
      "margin-top": "-5px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Keep up with updates on all our services")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2 "
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.process_message))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline",
      "white-space": "nowrap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription.email),
      expression: "subscription.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Enter your Email"
    },
    domProps: {
      "value": (_vm.subscription.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subscription.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.subscribe
    }
  }, [_vm._v("Subscribe")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _vm._m(9)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/home-banner-new.jpg')"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "0em",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carousel-home-slider",
      "data-ride": "carousel"
    }
  }, [_c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "item active home-slide"
  }, [_c('div', {
    staticClass: "mobi-off home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/home-banner-cn.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobi-on home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/home-banner-cn-mobile.png')"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item home-slide"
  }, [_c('div', {
    staticClass: "mobi-off home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/insure-moto-slide.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobi-on home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/insure-moto-slide-mobile.png')"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item home-slide"
  }, [_c('div', {
    staticClass: "mobi-off home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/discount-bazaar-slide.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobi-on home-slide-image col-sm-12",
    staticStyle: {
      "background-image": "url('static/assets/img/discount-bazaar-slide-mobile.png')"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-banner-bubble",
    staticStyle: {
      "z-index": "9",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "container intro-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 col-xs-12"
  }, [_c('h1', {
    staticClass: "intro-big"
  }, [_vm._v("\"Earning May Be Stressful, Getting A Great Service Shouldn't Be\" ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("What need would you like us to help you meet? Click below menus to explore Cityneeds.")])]), _vm._v(" "), _c('div', {
    staticClass: "fine-box-list"
  }, [_c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you want to Pay a "), _c('span', {
    staticClass: "catchy-wrap catchy-y"
  }, [_vm._v("Bill")]), _vm._v("? ")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("PAY\r\n                                            DSTV, REMITA, AIRTIME, ELECTRICITY...\r\n                                        ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/discountbazaar"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you want to attract shoppers and boost "), _c('span', {
    staticClass: "catchy-wrap catchy-y"
  }, [_vm._v("sales")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("SETUP DiscountBazaar")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/discountbazaar"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v(" Do you want to save money while "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("shopping")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v("SEARCH DiscountBazaar")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/insuremoto-cornerstoneinsurance"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you want to "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("buy or renew your")]), _vm._v(" vehicle insurance?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("Buy InsureMoto ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.houseaggregator.com",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v("Do you want to "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("share, sell, buy, or rent ")]), _vm._v("a property?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v(" Visit Houseaggregator ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "cnpros"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v("Do you need a skilled "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("worker/artisan")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v("FIND TILER, MASON, ELECTRICIAN... ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "businesses"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v("Do you need a Business "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("Directory")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("FIND DENTIST, LAWYER,  BAKER... ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "business-listings"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_yb",
    attrs: {
      "id": "bg_wrap_by"
    }
  }, [_c('h4', [_vm._v("Do you "), _c('span', {
    staticClass: "catchy-wrap catchy-b"
  }, [_vm._v("own")]), _vm._v(" a business and want to widen your reach?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_by"
  }, [_vm._v("LIST IT ")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "cnpro-accounts"
    }
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 fine-box-wrap"
  }, [_c('div', {
    staticClass: "fine-box bg_wrap_by",
    attrs: {
      "id": "bg_wrap_yb"
    }
  }, [_c('h4', [_vm._v(" Do you have a "), _c('span', {
    staticClass: "catchy-wrap catchy-y"
  }, [_vm._v("skill")]), _vm._v(" and want to work?")]), _vm._v(" "), _c('p', {
    staticClass: "bg_wrap_yb"
  }, [_vm._v("LIST IT (subject to approval ) ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxable-cta-left col-md-7 pull-left hidden-sm hidden-xs",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1.5em",
      "text-align": "left",
      "color": "#ffffff",
      "line-height": "1.8",
      "font-size": "16px"
    }
  }, [_c('p', [_vm._v("CNsurveys is all about inclusive ideas that fosters growth and development.")]), _vm._v(" "), _c('p', [_vm._v("The more Nigerians are able to participate in the creation of products, and polices that are designed for them, the greater the utilitarian value derived.")]), _vm._v(" "), _c('p', [_vm._v("CNsurveys enables business owners, and policy makers bounce off ideas on their target audience, use the feedback received as an affirmation of their concept, or a call to rejig, as the case maybe, thereby creating products, and policies that meet the aspiration of the people.")]), _vm._v(" "), _c('p', [_vm._v("We enjoin you to be steadfast in your contribution to the growth and development of Naija, as we look forward to your honest answers on our daily CNsurveys.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "color": "#fff",
      "margin-top": "-5px",
      "font-size": "18px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Take "), _c('span', {
    staticStyle: {
      "color": "#f8d732",
      "font-weight": "bold"
    }
  }, [_vm._v("CNsurveys")]), _vm._v(" - what Naija thinks")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-xs-12 regular-boxes"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#000",
      "margin-bottom": "-4px"
    }
  }, [_vm._v("New or Old in Town?")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "bold"
    }
  }, [_vm._v("We've got you covered")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Search for your proposed job category."), _c('br'), _vm._v("Choose from a pool of listed Service Professionals (CNpros) that match the job\r\n                                    ")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/new-in-city.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "cta_call"
  }, [_c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "color": "#ff0000"
    }
  }), _vm._v(" 080-3225-8453 ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a_cta",
    staticStyle: {
      "padding-top": "1em",
      "margin-top": "2em"
    }
  }, [_c('a', {
    staticClass: "btn a_mail a_mail_lg",
    attrs: {
      "href": "mailto:interact@cityneeds.ng?Subject=Hello%20cityneeds",
      "target": "_top"
    }
  }, [_vm._v("Send us a Mail at interact@cityneeds.ng")]), _vm._v(" "), _c('a', {
    staticClass: "btn a_mail a_mail_xs",
    attrs: {
      "href": "mailto:interact@cityneeds.ng?Subject=Hello%20cityneeds",
      "target": "_top"
    }
  }, [_vm._v("Send us a Mail at"), _c('br'), _vm._v(" interact@cityneeds.ng")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "prompt",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', {
    staticStyle: {
      "color": "#22baae",
      "font-weight": "bold"
    }
  }, [_vm._v("Transact Quicker- Add Cityneeds to Home screen:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "1.8",
      "color": "#000000"
    }
  }, [_vm._v("While on Cityneeds' webpage, tap the menu button ("), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(") at the top right corner of your browser, the menu list will drop down, tap Add to Home screen. Done!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d0fda89"}!./src/components/Home/template.html
// module id = 286
// module chunks = 0